var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListCheckOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.701 14.2868C27.0645 14.6441 27.0972 15.2111 26.7956 15.606L26.7132 15.701L19.8506 22.701C19.4895 23.0683 18.9154 23.0973 18.5207 22.7874L18.426 22.7028L14.2886 18.515C13.9005 18.1221 13.9043 17.489 14.2972 17.1008C14.6598 16.7426 15.2272 16.7183 15.6177 17.0257L15.7114 17.1094L19.135 20.575L25.2868 14.299C25.6739 13.9052 26.3071 13.8997 26.701 14.2868ZM9.5 17C10.0523 17 10.5 17.4477 10.5 18C10.5 18.5523 10.0523 19 9.5 19H4.5C3.94772 19 3.5 18.5523 3.5 18C3.5 17.4477 3.94772 17 4.5 17H9.5ZM21.5 11C22.0523 11 22.5 11.4477 22.5 12C22.5 12.5523 22.0523 13 21.5 13H4.5C3.94772 13 3.5 12.5523 3.5 12C3.5 11.4477 3.94772 11 4.5 11H21.5ZM21.5 5C22.0523 5 22.5 5.44772 22.5 6C22.5 6.55228 22.0523 7 21.5 7H4.5C3.94772 7 3.5 6.55228 3.5 6C3.5 5.44772 3.94772 5 4.5 5H21.5Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListCheckOutline);
export default __webpack_public_path__ + "static/media/list_check_outline.41f72824db787c19f720ef03e8313f2e.svg";
export { ForwardRef as ReactComponent };